$(document).ready(function () {
    window.currentSlideImage = 0;

    function kenburnsImages() {
        const slides = document.querySelectorAll('.slideshow .slideshow-image');

        if (window.currentSlideImage >= slides.length) {
            window.currentSlideImage = 0;
        }

        slides.forEach(function (node, index) {
            if(window.currentSlideImage === index) {
                node.style.opacity = 1;
                node.style.zIndex = 1000;
                node.style.transition = 'opacity 350ms ease-in'
            } else {
                node.style.opacity = 0.5;
                node.style.zIndex = index;
            }
        });

        window.currentSlideImage++;
    }

    window.intervalId = window.setInterval(kenburnsImages, 5000);

    //clean interval
    window.setTimeout(function() {
        // console.log('removing interval: ', window.intervalId);

        if(window.intervalId) {
            window.clearInterval(window.intervalId);
            window.intervalId = null;
        }
    }, 120 * 1000);
});